export default {
  CARDS: 'Cards',
};
